<template>
    <div class="row">
        <div v-for="item in items" :key="item.id" class="col-lg-4 col-md-6 wow move-up">
            <div class="service-grid">
                <div class="ht-service-box--two text-center style-03">
                    <router-link to="">
                        <div class="image mb-20">
                            <img :src="item.icon" class="img-fluid" alt="aeroland-startup-box-icon-01">
                        </div>
                        <div class="content">
                            <h6 class="heading">{{ item.heading }}</h6>
                            <div class="service_text">{{ item.text }}</div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'StartUpFeatureTwo',
        data (){
            return {
                items: [
                    {
                       icon: require('../assets/img/icons/aeroland-startup-box-icon-01.png'), 
                       heading: 'Web Development', 
                       text: "From concept to solution I am a full stack developer who can quickly prototype business ideas. I'm confident I can help you and your business thrive digitally."
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-startup-box-icon-02.png'), 
                        heading: 'Social Media', 
                        text: 'I work with designers to create stunning social media campaigns. I also use my software engineering expertise to handcraft custom solutions for your businesses need.'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-startup-box-icon-03.png'), 
                        heading: 'SEO Marketing', 
                        text: 'To maximize your presence online you must be easily found. My SEO expertise includes ranked search and increased visibility.'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-startup-box-icon-04.png'), 
                        heading: 'Site Management', 
                        text: 'Our site managment program allows you to put your digital presence on autopilot. We handle software updates, site modifications, and other routine maintenance so you can focus on your business.'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-startup-box-icon-05.png'), 
                        heading: 'Email Campaigns', 
                        text: 'Engage your existing customers and gain new customers buy allowing me to run your email campaigns. Email still works and is a great way to generate paying leads.'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-startup-box-icon-06.png'), 
                        heading: 'Software Consulting', 
                        text: "Have an idea but don't know how to code? I can give you unique developer insights that you can use to find a technical cofounder or offshore your project."
                    },
                ]
            }
        }
    }
</script>
